module.exports = __webpack_public_path__ + "static/TWAUS-trader-text-31a6ed0e90c027ac0da62a5ecf9cd522.png";